<template>
  <b-card>
    <b-tabs @activate-tab="changeTabs($event)" content-class="mt-3">
      <b-tab title="گزارش تسویه ها" active>
        <div>
          <list-table :fields="fields" :url="url" :excelroute="true" :params="params"></list-table>
        </div>
      </b-tab>
      <b-tab title="مانده ها">
        <creditors v-if="enable"></creditors>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<style>
.ltr-dir {
  direction: ltr;
}
</style>
<script>
import TableShowData from "@/components/table";
import { GET_USER_LIST } from "@/core/services/store/getUserList.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import bankDeposit from "./BankDeposit.vue";
import moment from "jalali-moment";
export default {
  name: "AccountersReportSharing",

  data() {
    return {
      url: "~reports/api/transfers",
      enable: false,
      fields: [
        {
          key: "created_at",
          label: "تاریخ درخواست",
          formatter(value, key, item) {
            return moment(value).format("jYYYY/jMM/jDD hh:mm:ss");
          },
          tdClass: "ltr-dir",
        },
        {
          key: "website_name",
          label: "نام وبسایت",
        },
        {
          key: "nickname",
          label: "نام و نام خانوادگی",
        },

        {
          key: "shaba_number",
          label: "شماره شبا",
        },
        {
          key: "tracking_number",
          label: "کد رهگیری",
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
          tdClass(value, key, item) {
            if (item.amount > 0) {
              return "text-success";
            }
            return "text-danger";
          },
        },
        {
          key: "wage",
          label: "کارمزد",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
          tdClass(value, key, item) {
            if (item.amount > 0) {
              return "text-success";
            }
            return "text-danger";
          },
        },
        {
          key: "status",
          label: "وضعیت",
          formatter(value, key, item) {
            return value;
          },
          tdClass(value, key, item) {
            switch (value) {
              case "انجام نشده":
                return "text-warning";
              case "انجام شده":
                return "text-success";
              case "لغو شده":
                return "text-danger";
              case "عودت شده":
                return "text-danger";
            }
          },
        },
        {
          key: "submit_date",
          label: "تاریخ واریز",
          formatter(value, key, item) {
            if (value) return moment(value).format("jYYYY/jMM/jDD hh:mm:ss");
            else
              return moment(item.created_at).format("jYYYY/jMM/jDD hh:mm:ss");
          },
          tdClass: "ltr-dir",
        },
        {
          key: "from_bank",
          label: "بانک مبدا",
        }
      ],

      params: [
        {
          label: "از تاریخ:",
          field: "date_from",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "date_to",
          type: "date-picker",
        },
        {
          label: "پذیرنده",
          field: "user_id",
          type: "select",
          value: null,
          options: [],
        },
        {
          label: "تاریخ واریز از:",
          field: "submit_date_from",
          type: "date-picker",
        },
        {
          label: "تاریخ واریز تا:",
          field: "submit_date_to",
          type: "date-picker",
        },
        {
          label: "کد رهگیری:",
          field: "tracking_number",
          type: "text",
        },
        {
          label: "شماره شبا:",
          field: "shaba_number",
          type: "text",
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
    creditors: bankDeposit,
  },
  computed: {
    loadedUserList() {
      return this.$store.getters.loadedUserList;
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "گزارشات مالی",
        route: "merchants",
      },
      {
        title: "تسهیم ها",
      },
    ]);
    this.getUserList();
  },
  methods: {
    getUserList() {
      this.$store.dispatch(GET_USER_LIST, "users-with-sharing").then((data) => {
        let option = [{ text: "انتخاب نشده", value: null }];
        data.forEach((element) => {
          option.push({
            text: element.name + " ( " + element.mobile + " )",
            value: element.id,
          });
        });

        this.params[2].options = option;
      });
    },
    changeTabs(e) {
      e == 1 ? (this.enable = true) : null;
    },
  },
};
</script>